var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerHover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.875H20.25C19.422 16.875 18.75 17.547 18.75 18.375C18.75 19.203 19.422 19.875 20.25 19.875H22.5C23.328 19.875 24 19.203 24 18.375C24 17.547 23.328 16.875 22.5 16.875Z",
    fill: "#3EE7CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.875H1.5C0.672 16.875 0 17.547 0 18.375C0 19.203 0.672 19.875 1.5 19.875H13.5C14.328 19.875 15 19.203 15 18.375C15 17.547 14.328 16.875 13.5 16.875Z",
    fill: "#3EE7CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.375H3.75C4.578 3.375 5.25 4.047 5.25 4.875C5.25 5.703 4.578 6.375 3.75 6.375H1.5C0.672 6.375 0 5.703 0 4.875C0 4.047 0.672 3.375 1.5 3.375Z",
    fill: "#3EE7CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.375H22.5C23.328 3.375 24 4.047 24 4.875C24 5.703 23.328 6.375 22.5 6.375H10.5C9.672 6.375 9 5.703 9 4.875C9 4.047 9.672 3.375 10.5 3.375Z",
    fill: "#3EE7CD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 10.125H22.5C23.328 10.125 24 10.797 24 11.625C24 12.453 23.328 13.125 22.5 13.125H6.375C5.547 13.125 4.875 12.453 4.875 11.625C4.875 10.797 5.547 10.125 6.375 10.125Z",
    fill: "#3EE7CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerHover);
export default __webpack_public_path__ + "static/media/hamburger-hover.2977fe13dcff975f38fa4e17ee33f20b.svg";
export { ForwardRef as ReactComponent };